import { render, staticRenderFns } from "./PurchaseActivityFlashLayout.vue?vue&type=template&id=8e01d45a&"
import script from "./PurchaseActivityFlashLayout.vue?vue&type=script&lang=js&"
export * from "./PurchaseActivityFlashLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e01d45a')) {
      api.createRecord('8e01d45a', component.options)
    } else {
      api.reload('8e01d45a', component.options)
    }
    module.hot.accept("./PurchaseActivityFlashLayout.vue?vue&type=template&id=8e01d45a&", function () {
      api.rerender('8e01d45a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/main-column/PurchaseActivityFlashLayout.vue"
export default component.exports